import buildService, { NoParams } from 'common/utils/build-service'
import { GET } from 'common/requests'
import { BlogPost } from './types'

const BLOG_POSTS_SELECT =
  'id,title,description,excerpt,video_url,image_url,status,slug,created_at,updated_at,blog_category:blog_categories(id,name)'

export const getBlogPostsService = buildService<NoParams, BlogPost, unknown, BlogPost>({
  type: GET,
  constantsPrefix: 'BLOG_POSTS',
  isArray: true,
  http: {
    createApiUrlSuffix: () =>
      `/blog_posts?select=${BLOG_POSTS_SELECT}&order=updated_at.desc&status=eq.published`,
  },
})

export const getBlogPostBySlugService = buildService<string, BlogPost, unknown, BlogPost>({
  type: GET,
  constantsPrefix: 'BLOG_POST_DETAILS',
  isArray: false,
  http: {
    createApiUrlSuffix: (slug) => `/blog_posts?slug=eq.${slug}&select=${BLOG_POSTS_SELECT}`,
    headers: {
      Accept: 'application/vnd.pgrst.object+json',
    },
  },
})
